const OVERRIDE_EXTERNAL_LINK = 'override-external-link';

export { OVERRIDE_EXTERNAL_LINK };
